import ViewUser from './ViewUser';

export default ViewUser;
